import { i18n } from '@/i18n'
// import store from '@/store'

export default (params) => {
  const menu = [
    {
      icon: 'config',
      name: i18n.t('products.header'),
      path: 'masters/products',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'masters/products/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('products.impuestos'),
          path: 'masters/products/impuestos',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('historical.entity_name'),
          path: 'masters/products/historical',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
      ]
    }
  ]
  if (params.issuingCreation) {
    menu[0].sc = menu[0].sc.slice(0, 1)
  }
  return menu
}
